<template>
  <div>
    <!-- 面包屑导航区域 -->
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item>Equipment Mgmt</el-breadcrumb-item>
      <el-breadcrumb-item>Equipment Pay</el-breadcrumb-item>
    </el-breadcrumb>
    <!-- 卡片视图区域 -->
    <el-card>
      <!-- 搜索与添加区域 -->
      <collapse @getDataList="search">
        <collapse-item>
          <span>Device ID:</span>
          <el-input
            placeholder="please input the Device ID"
            v-model.trim="queryInfoparams.params.uniqueCode"
            clearable
          ></el-input>
        </collapse-item>
        <collapse-item v-if="this.type !== '3'">
          <span class="span1">Plumber Company:</span>
          <el-select
            v-model="queryInfoparams.params.companyId"
            filterable
            placeholder
            clearable
          >
            <el-option
              v-for="item in companyList"
              :key="item.id"
              :label="item.companyName"
              :value="item.id"
            ></el-option>
          </el-select>
        </collapse-item>
        <collapse-item v-if="this.type === '1'">
          <span>Agent:</span>
          <!-- <el-input placeholder="please input agant" v-model.trim="queryInfoparams.params.agencyName" clearable></el-input> -->
          <el-select
            v-model="queryInfoparams.params.agencyId"
            filterable
            placeholder
            clearable
          >
            <el-option
              v-for="item in agencyList"
              :key="item.id"
              :label="item.agencyName"
              :value="item.id"
            ></el-option>
          </el-select>
        </collapse-item>
        <collapse-item>
          <span class="demonstration">Service start time:</span>
          <el-date-picker
            v-model="startTime0"
            type="daterange"
            range-separator="to"
            start-placeholder="start Date"
            value-format="yyyy-MM-dd"
            format="yyyy-MM-dd"
            end-placeholder="end Date"
            @change="selectHandler"
          ></el-date-picker>
        </collapse-item>
        <collapse-item>
          <span class="demonstration">Service expiration time:</span>
          <el-date-picker
            v-model="stopTime1"
            type="daterange"
            range-separator="to"
            start-placeholder="start Date"
            value-format="yyyy-MM-dd"
            format="yyyy-MM-dd"
            end-placeholder="end Date"
            @change="selectHandler"
          ></el-date-picker>
        </collapse-item>
        <collapse-item>
          <span class="demonstration">Sale Date:</span>
          <el-date-picker
            v-model="calibrationTime1"
            type="daterange"
            range-separator="to"
            start-placeholder="start Date"
            value-format="yyyy-MM-dd"
            format="yyyy-MM-dd"
            end-placeholder="end Date"
            @change="selectHandler"
          ></el-date-picker>
        </collapse-item>
        <collapse-item>
          <span>payment status:</span>
          <el-select
            v-model="queryInfoparams.params.status"
            placeholder=" "
            clearable
          >
            <el-option
              v-for="item in payStatus"
              :key="item.item_code"
              :label="item.item_name"
              :value="item.item_code"
            ></el-option>
          </el-select>
        </collapse-item>
        <collapse-item>
          <span>Write-off Status:</span>
          <el-select v-model="queryInfoparams.params.cancellationStatus" placeholder clearable>
            <el-option label="Waiting for write off" value="0"></el-option>
            <el-option label="Written off" value="1"></el-option>
          </el-select>
        </collapse-item>
        <collapse-item>
          <span>Plumber name:</span>
          <!-- <el-input placeholder="please input the plumber" v-model.trim="queryInfoparams.params.uniqueCode" clearable></el-input> -->
          <el-select
            v-model="queryInfoparams.params.engineerId"
            filterable
            placeholder=" "
            clearable
          >
            <el-option
              v-for="item in engineerList"
              :key="item.id"
              :label="item.lastName"
              :value="item.id"
            ></el-option>
          </el-select>
        </collapse-item>
      </collapse>
      <el-row type="flex" justify="end">
        <el-col class="searchBtns" :span="6">
          <el-button-group>
            <el-button
              size="small"
              v-hasPermission="['equipmentPay:view']"
              @click="clickHandlerToEquipment"
            >view equipment</el-button>
            <el-button
              size="small"
              v-hasPermission="['equipmentPay:settleAccount']"
              @click="showSettleAccounts()"
            >Settle Accounts</el-button>
            <el-button
              size="small"
              v-hasPermission="['equipmentPay:payment']"
              @click="showEditDialogOfTable()"
            >Equipment Payment</el-button>
            <el-button
              plain
              size="small"
              v-hasPermission="['equipmentPay:save']"
              icon="el-icon-share"
              @click="addDialogVisible = true"
            >Register Device</el-button>
            <el-button
              size="small"
              icon="el-icon-download"
              v-hasPermission="['equipmentPay:export']"
              @click="exportExcel"
            >Export</el-button>
          </el-button-group>
        </el-col>
      </el-row>
      <!-- 设备服务计费列表区域 -->
      <el-table
        ref="multipleTable"
        :data="equipmentPayList"
        @selection-change="handleSelectionChange"
        border
        stripe
      >
        <el-table-column type="selection"></el-table-column>
        <el-table-column type="index" label="No."></el-table-column>
        <el-table-column label="Device ID" sortable prop="uniqueCode" width="190"></el-table-column>
        <el-table-column label="Sale date" sortable prop="saleDate" width="120"></el-table-column>
        <el-table-column label="Free period(Days)" sortable prop="freeCycle" width="160"></el-table-column>
        <el-table-column label="Remaining free period" sortable prop="attribute10" width="190"></el-table-column>
        <el-table-column label="Fisrt start" sortable prop="firstUseDate" width="150"></el-table-column>
        <el-table-column label="agent" sortable prop="agencyName" width="140"></el-table-column>
        <el-table-column label="Plumber company" sortable prop="companyName" width="160"></el-table-column>
        <el-table-column label="Plumber name" sortable prop="attribute2" width="140"></el-table-column>
        <el-table-column label="Service start date" sortable prop="serviceStartDate" width="160"></el-table-column>
        <el-table-column label="Service expiration time" sortable prop="serviceEndDate" width="190"></el-table-column>
        <el-table-column label="Payment status" sortable prop="status" width="140">
          <template slot-scope="scope">
            <el-tag v-if="scope.row.status==='0'" type="success">Normal</el-tag>
            <el-tag v-else-if="scope.row.status ==='1'" type="info">Arrears</el-tag>
            <el-tag v-else-if="scope.row.status ==='2'" type="info">Suspension of payment</el-tag>
          </template>
        </el-table-column>
        <el-table-column label="Currency" sortable prop="unit" width="100"></el-table-column>
        <el-table-column label="Service fee amount" sortable prop="serviceAmount" width="170"></el-table-column>
        <el-table-column
          label="Cumulative suspended days"
          sortable
          prop="serviceStopTime"
          width="220"
        ></el-table-column>
        <el-table-column
          label="Headquarters charging start time"
          sortable
          prop="headquartersStartDate"
          width="250"
        ></el-table-column>
        <el-table-column
          label="Headquarters charge deadline"
          sortable
          prop="headquartersEndDate"
          width="230"
        ></el-table-column>
        <el-table-column label="Write-off status" sortable prop="cancellationStatus" width="150">
          <template slot-scope="scope">
            <el-tag v-if="scope.row.cancellationStatus==='0'" type="success">Waiting for write off</el-tag>
            <el-tag v-else-if="scope.row.cancellationStatus ==='1'" type="info">Written off</el-tag>
          </template>
        </el-table-column>
        <el-table-column label="Equipment status" sortable prop="statusOfEquipment" width="160">
          <template slot-scope="scope">
            <el-tag v-if="scope.row.statusOfEquipment==='1'" type="success">Enable</el-tag>
            <el-tag v-else-if="scope.row.statusOfEquipment ==='2'" type="info">Disable</el-tag>
            <el-tag v-else-if="scope.row.statusOfEquipment === '3'" type="info">Terminated</el-tag>
          </template>
        </el-table-column>
        <el-table-column v-if="this.type !== '3'" label="operation"  show-overflow-tooltip width="120px" fixed="right" >
          <template slot-scope="scope">
            <div class="btnContainer">
              <!-- 修改按钮 -->
              <el-link
                icon="el-icon-edit"
                v-hasPermission="['equipmentPay:edit']"
                @click="showEditDialog(scope.row.id)"
              >Edit</el-link>
            </div>
          </template>
        </el-table-column>
      </el-table>
      <!-- 分页区域 -->
      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="queryInfoparams.current"
        :page-sizes="[10, 50, 100, 200]"
        :page-size="queryInfoparams.size"
        layout="total, sizes, prev, pager, next, jumper"
        :total="total"
      ></el-pagination>
    </el-card>
    <!-- 编辑的对话框   合并为一个对话框-->
    <el-dialog
      title="Edit Device"
      :visible.sync="editDialogVisible"
      width="50%"
      @close="editDialogClosed"
    >
      <el-form :model="addForm" :rules="addFormRules" ref="editFormRef" label-width="250px">
        <el-form-item
          v-if="addForm.firstUseDate === null"
          label="Device ID"
          label-width="130px"
          prop="uniqueCode"
        >
          <el-input v-model="addForm.uniqueCode" clearable></el-input>
        </el-form-item>
        <el-form-item
          v-if="addForm.firstUseDate === null"
          label="Plumber Company"
          label-width="130px"
        >
          <el-select v-model="addForm.companyId" filterable placeholder clearable>
            <el-option
              v-for="item in companyList"
              :key="item.id"
              :label="item.companyName"
              :value="item.id"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item
          v-if="addForm.firstUseDate === null"
          label="Plumber Name"
          label-width="130px"
          prop="context"
        >
          <el-select
            v-model="addForm.engineerId"
            value-key="id"
            filterable
            placeholder=" "
            clearable
          >
            <el-option
              v-for="item in engineerList"
              :key="item.id"
              :label="item.lastName"
              :value="item.id"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="Sale date" label-width="130px" prop="context">
          <el-date-picker
            v-model="addForm.saleDate"
            type="date"
            start-placeholder="start Date"
            value-format="yyyy-MM-dd"
            format="yyyy-MM-dd"
          ></el-date-picker>
        </el-form-item>
        <el-form-item
          v-if="addForm.attribute10 !== 0 || addForm.firstUseDate === null "
          label="Free period(Days)"
          label-width="130px"
          prop="freeCycle"
        >
          <el-input v-model="addForm.freeCycle"></el-input>
        </el-form-item>
        <el-row :gutter="24">
          <el-col :span="16">
            <el-form-item label="service amount" prop="serviceAmount" label-width="140px">
              <el-input v-model="addForm.serviceAmount" clearable></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="currency" prop="unit">
              <el-select
                label="currency"
                v-model="addForm.unit"
                placeholder="please choose the  type"
              >
                <el-option
                  v-for="item in currency"
                  :key="item.item_code"
                  :label="item.item_name"
                  :value="item.item_code"
                ></el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="editDialogVisible = false">cancel</el-button>
        <el-button type="primary" @click="editEquipmentPayInfo">save</el-button>
      </span>
    </el-dialog>
    <!-- 添加对话框的对话框   合并为一个对话框-->
    <el-dialog slot="title" :visible.sync="addDialogVisible" width="60%" @close="addDialogClosed">
      <template slot="title">
        <div>
          <h3>Register Device</h3>
          <el-divider style="font-weight:bold;"></el-divider>
        </div>
      </template>
      <el-form :model="addForm" :rules="addFormRules" ref="addFormRef" label-width="220px">
        <el-row :gutter="20">
          <el-col :span="10">
            <el-form-item label="Device ID" prop="uniqueCode">
              <el-input @blur="checkUniqueCodeExist" v-model="addForm.uniqueCode" clearable></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="10">
            <el-form-item label="Sale date" prop="saleDate">
              <el-date-picker
                v-model="addForm.saleDate"
                type="date"
                start-placeholder="start Date"
                value-format="yyyy-MM-dd"
                format="yyyy-MM-dd"
              ></el-date-picker>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="20">
          <el-col :span="10">
            <el-form-item label="service amount" prop="serviceAmount">
              <el-input v-model="addForm.serviceAmount" clearable></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="10">
            <el-form-item label="currency" prop="unit">
              <el-select
                label="currency"
                v-model="addForm.unit"
                placeholder="please choose the  type"
              >
                <el-option
                  v-for="item in currency"
                  :key="item.item_code"
                  :label="item.item_name"
                  :value="item.item_code"
                ></el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="20">
          <el-col :span="10">
            <el-form-item label="Free period(Days)" prop="freeCycle">
              <el-input v-model="addForm.freeCycle" clearable></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="10">
            <el-form-item label="Plumber Company">
              <el-select v-model="addForm.companyId" filterable placeholder clearable>
                <el-option
                  v-for="item in companyList"
                  :key="item.id"
                  :label="item.companyName"
                  :value="item.id"
                ></el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="20">
          <el-col :span="10">
            <el-form-item label="Plumber Name" prop="context">
              <el-select
                v-model="addForm.engineerId"
                default-first-option
                filterable
                placeholder
                clearable
              >
                <el-option
                  v-for="item in engineerList"
                  :key="item.id"
                  :label="item.lastName"
                  :value="item.id"
                >
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="10">
            <el-form-item label="Agent" v-if="this.type === '1'"   prop="agencyId">
              <el-select
                v-model="addForm.agencyId"
                filterable
                placeholder
                clearable
                >
                <el-option
                  v-for="item in agencyList"
                  :key="item.id"
                  :label="item.agencyName"
                  :value="item.id"
                ></el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="addDialogVisible = false">Cancel</el-button>
        <el-button type="primary" @click="saveEquipmentPayInfo">Save</el-button>
      </span>
    </el-dialog>
    <!-- 设备付款对话框-->
    <el-dialog
      title="Equipment Payment"
      :visible.sync="editDialogVisiblePay"
      @closed="editCloseHandler"
      width="90%"
    >
      <el-table :data="tableData" border style="width:100%">
        <el-table-column property="paymentAmount" label="Payment amount">
          <template slot-scope="scope">
            <el-input
              label="Payment amount"
              v-model="scope.row.paymentAmount"
              @change="paymentHandler"
              clearable
            ></el-input>
          </template>
        </el-table-column>
        <el-table-column property="paymentYears" label="Years of payment">
          <template slot-scope="scope">
            <el-input
              label="Years of payment"
              v-model="scope.row.paymentYears"
              @change="paymentHandler"
              clearable
            ></el-input>
          </template>
        </el-table-column>
        <el-table-column property="serviceAmount" label="service  amount"></el-table-column>
        <el-table-column property="freeCycle" label="Free cycle"></el-table-column>
        <el-table-column property="status" label="Payment status"></el-table-column>
        <el-table-column property="unit" label="Crrency"></el-table-column>
        <el-table-column property="serviceStartDate" label="Service start time"></el-table-column>
      </el-table>
      <span slot="footer" class="dialog-footer">
        <span>payment amount({{unit}})：{{totalOfPaymentAmount}}</span>
        <el-button @click="editDialogVisiblePay = false">Cancel</el-button>
        <el-button type="primary" @click="EquipmentPaymentInfo">Save</el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
import db from '@/services/localstorage'
import Collapse from '@/components/collapse/Collapse'
import CollapseItem from '@/components/collapse/CollapseItem'
export default {
  components: {
    Collapse,
    CollapseItem,
  },
  data() {
    var checkserviceAmount = (rule, value, cb) => {
      // 表单校验正则表达式
      const reg = /^[0-9]*$/
      if (reg.test(value)) {
        return cb()
      }
      cb(new Error('Amount must be a number'))
    }
    var resFreecycle = (rule, value, cb) => {
      const resFreec = /^[0-9]*$/
      if (resFreec.test(value)) {
        return cb()
      }
      cb(new Error('Amount must be a number'))
    }
    return {
      stopTime1: '',
      calibrationTime1: '',
      startTime0: '',
      queryInfoparams: {
        // 当前页码
        current: 0, // @ts-nocheck
        // 查询参数
        params: {},
        // 当前每页显示多少条数据
        size: 10,
        // 排序字段
        sortField: '',
        // ASC  DESC 顺序
        sortOrder: '',
      },
      user: {},
      flag: true,
      addDialogVisible: false,
      // 设备列表
      equipmentPayList: [],
      agencyList: [],
      total: 0,
      tableData: [],
      currency: [
        {
          item_name: '',
          item_code: '',
        },
      ],
      payStatus: [],
      unit: '',
      type: '',
      engineerList: [],
      companyList: [],
      // 控制添加 用户对话框的显示与隐藏
      // 设备校准表单数据
      addForm: {
        uniqueCode: '',
        saleDate: '',
        agencyId: '',
        freeCycle: '',
        companyId: '',
        engineerId: '',
        attribute10: '',
        serviceAmount: '',
      },
      tatalServiceAmount: '',
      addEquipmentPayLog: [
        {
          uniqueCode: '',
          agencyId: '',
          companyId: '',
          paymentAmount: '',
          paymentYears: '',
          unit: '',
        },
      ],
      //添加表单校验
      addFormRules: {
        saleDate: [
          {
            required: true,
            message: 'Date cannot be empty,plaese input the date',
            trigger: 'blur',
          },
        ],
        serviceAmount: [
          {
            required: true,
            message: 'please input the service amount',
            trigger: 'blur',
          },
          { validator: checkserviceAmount },
        ],
        freeCycle: [
          {
            required: true,
            message: 'please input the service amount',
            trigger: 'blur',
          },
          { validator: resFreecycle },
        ],
        unit: [
          {
            required: true,
            message: 'please input the currency',
            trigger: 'blur',
          },
        ],
        agencyId: [
          {
            required: true,
            message:'The  agent  cannot be empty ',
            trigger: 'biur',
          },
        ],
        uniqueCode: [
          {
            required: true,
            message:
              'The unique device code cannot be empty and cannot be the same',
            trigger: 'biur',
          },
        ],
      },
      totalOfPaymentAmount: '',
      editForm: {},
      editDialogVisible: false,
      editDialogVisiblePay: false,
    }
  },
  methods: {
    async exportExcel() {
      console.log('-----------')
      let res = this.$export(
        'equipmentPay/exportExcel',
        JSON.stringify(this.queryInfoparams),
        'equipmentPay'
      )
    },
    //点击跳转到对应的设备管理界面
    clickHandlerToEquipment() {
      this.$router.push('/equipment/Equipment')
    },
    //查询输入框回调函数，清空条件
    selectHandler() {
      //将时间区间，分成两个参数传到后端
      if (this.startTime0 !== null) 
      {
        this.queryInfoparams.params.serviceStartDate = this.startTime0[0]
        this.queryInfoparams.params.endServiceStartDate = this.startTime0[1]
      }
      else{
        this.queryInfoparams.params.serviceStartDate = ""
        this.queryInfoparams.params.endServiceStartDate = ""
      }

      if (this.stopTime1 !== null) 
      {
        this.queryInfoparams.params.serviceEndDate = this.stopTime1[0]
        this.queryInfoparams.params.endServiceEndDate = this.stopTime1[1]
      }
      else{
        this.queryInfoparams.params.serviceEndDate = ""
        this.queryInfoparams.params.endServiceEndDate = ""
      } 
      if (this.calibrationTime1 !== null) 
      {
        this.queryInfoparams.params.saleDate = this.calibrationTime1[0]
        this.queryInfoparams.params.saleDateTo = this.calibrationTime1[1]
      }
      else{
        this.queryInfoparams.params.saleDate = ""
        this.queryInfoparams.params.saleDateTo = ""
      } 
    },
    //点击回调,检验表格表单，，
    paymentHandler() {
      this.totalOfPaymentAmount = 0
      const numcheckRes = /^[0-9]*$/
      for (let i = 0; i < this.tableData.length; i++) {
        if (!numcheckRes.test(this.tableData[i].paymentAmount)) {
          this.flag = false
          this.tableData[i].paymentAmount = ''
          this.tableData[i].paymentYears = ''
          return this.$message.error('Invalid amount format')
        }
        if (!numcheckRes.test(this.tableData[i].paymentYears)) {
          this.flag = false
          this.tableData[i].paymentYears = ''
          return this.$message.error('Invalid amount format')
        }
        this.totalOfPaymentAmount += this.tableData[i].paymentAmount - 0
      }
    },
    //取消后回调，清空选择
    editCloseHandler() {
      this.$refs.multipleTable.clearSelection()
      this.totalOfPaymentAmount = ''
    },
    handleEditRows() {
      if (this.checkSelection()) {
        this.editTable.editRows(this.selection)
      }
    },
    handleSelectionChange(val) {
      this.tableData = val
    },
    //显示可编辑表格，逻辑校验，用于设备付款
    showEditDialogOfTable() {
      if (this.tableData.length > 0) {
        //table里面的数据不为空，可以打开可编辑表界面
        console.log('被选中', this.tableData)
        let flag = true //判断币种是否一致的标志 ，true为都一致  false为出现不一致
        let temYseOrNot = true
        let exitOrNot = true
        for (let i = 0; i < this.tableData.length; i++) {
          if (this.tableData[0].unit !== this.tableData[i].unit) {
            flag = false
          }

          if (this.tableData[i].statusOfEquipment === '3') {
            temYseOrNot = false
          }
          if (this.tableData[i].serviceEndDate === null) {
            exitOrNot = false
          }
          this.tableData[i].paymentAmount = '' //将编辑数据设置为空
          this.tableData[i].paymentYears = ''
        }

        if (
          flag === true &&
          temYseOrNot === true &&
          exitOrNot === true &&
          exitOrNot === true
        ) {
          console.log('批量更新', this.tableData)
          this.editDialogVisiblePay = true
        } else if (flag === false) {
          return this.$message.error(
            'The equipments are not the same currency, please select the same currency'
          )
        }else if (temYseOrNot === false) {
          return this.$message.error('Reminder: the device was down Confirm')
        } else if (exitOrNot === false) {
          return this.$message.error(
            'The service expiration time is empty, the device is not activated and cannot be paid'
          )
        } else {
          return this.$message.error('Non-business logic check error')
        }
      } else {
        console.log('没有被选中')
        // this.editDialogVisiblePay
        this.$message.success('Please select at least one row')
      }
    },
    //获取币种类型
    async getTestType() {
      this.$get(`dict/getByTypeCode/CURRENCY/Y`).then(({ data: res }) => {
        this.currency = res.data
      })
    },
    async getPaymentStatus() {
      this.$get(`dict/getByTypeCode/PAY_STATUS/Y`).then(({ data: res }) => {
        this.payStatus = res.data
      })
    },
    //结算，逻辑校验 ,,
    async showSettleAccounts() {
      var flag = true
      var path = ''
      var listAgency = {}
      this.tatalServiceAmount = this.tatalServiceAmount - 0
      if (this.tableData.length !== 0) {
        for (let i = 0; i < this.tableData.length; i++) {
          this.tatalServiceAmount += this.tableData[i].serviceAmount - 0
          listAgency += this.tableData[i].agencyName
          if (this.tableData[0].agencyId !== this.tableData[i].agencyId) {
            console.log('', this.tableData)
            path = 'agencyDis'
            flag = false
          }
          if (this.tableData[0].unit !== this.tableData[i].unit) {
            path = 'unitDis'
            flag = false
          }
        }
        if (flag === true) {
          //等于true就可以执行
          this.$confirm(
            `${this.tableData.length} equipments are going to be written off this time , is it confirmed?`,
            'Reminder',          
            {
              confirmButtonText: 'confirm',
              cancelButtonText: 'cancel',
              type: 'warning',
            }
          )
            .then(() => {
              this.$post('equipmentPay/settleAccounts', this.tableData).then(
                ({ data: res }) => {
                  console.log(res)
                  if (res.code !== 200) {
                    return this.$message.error('operation failed')
                  } else {
                    this.$message.success('Successful operation')
                    // 关闭对话框
                    this.tatalServiceAmount = ""
                    this.editDialogVisible = false
                    // 刷新数据列表
                    this.search()
                  }
                }
              )
            })
            .catch(() => {
              this.tatalServiceAmount = ''
              this.$message({
                type: 'error',
                message: 'Cancel operation',
              })
            })
        } else {
          switch (path) {
            case 'unitDis':
              this.tatalServiceAmount = ""
              return this.$message.error(
                'The equipments are not the same currency, please select the same currency.'
              )
            case 'agencyDis':
              this.tatalServiceAmount = ""
              return this.$message.error(
                'The equipments are not belong to the same agent and operation is not available.Please select the same agent !'
              ) //代理商不一致
            default:
              this.tatalServiceAmount = ""
              return this.$message.error(
                'Non-business logic verification error, please contact the administrator'
              )
          }
        }
      } else {
        return this.$message.error('Please select at least one row')
      }
    },
    handleSizeChange(newSize) {
      this.queryInfoparams.size = newSize
      this.getEquipmentPaytList()
    },
    // 监听页码值 改变的事件
    handleCurrentChange(newPage) {
      this.queryInfoparams.current = newPage
      this.getEquipmentPaytList()
    },

    // 点击按钮 添加新设备信息
    async saveEquipmentPayInfo() {

      this.user = db.get('user')
      if (this.user.userType === '2') {
        this.addForm.agencyId = this.user.companyId
      }
      this.$refs.addFormRef.validate(async (valid) => {
        if (!valid) return
        this.$post('equipmentPay/save', this.addForm).then(({ data: res }) => {
          if (res.code !== 200) return this.$message.error('Failure operation')
          this.$message.success('Successful operation')
          this.addForm = {}
          // 隐藏添加的对话框
          this.addDialogVisible = false
          // 刷新列表数据
          this.search()
        })
      })
    },
    //校验设备唯一编码
    async checkUniqueCodeExist() {
      if (this.addForm.uniqueCode == '') return
      this.$get(`equipmentPay/checkEquipmentPayByUniqueCode/${this.addForm.uniqueCode}`).then(({ data: res }) => {
        if (res.code === 200) {
          this.$message.error('这个设备编码已存在')
          setTimeout(() => {
            this.addForm.uniqueCode = ''
          }, 1000)
        }
      })
    },
    //设备付款，可以批量修改，并且提交信息
    async EquipmentPaymentInfo() {
      console.log(this.tableData)
      this.addEquipmentPayLog = this.tableData //把数据转换成设备缴费的的数据类型
      var nullNotOrYes = true
      for (let i = 0; i < this.tableData.length; i++) {
        var val1 = this.tableData[i].paymentAmount
        var val2 = this.tableData[i].paymentYears
        if (val1 === '' || val2 === '') {
          nullNotOrYes = false
        }
      }
      if (nullNotOrYes === true) {
        //如果表格没有为空的年数和支付金额
        this.$post(
          'equipmentPay/equipmentPayment',
          this.addEquipmentPayLog
        ).then(({ data: res }) => {
          console.log(res)
          if (res.msg !== 'SUCCESS' && res.msg !== 'Ineligible') {
            return this.$message.error('operation failed')
          } else if (res.msg === 'Ineligible') {
            return this.$message.error('Insufficient payment amount ！')
          } else if (this.flag === false) {
            return this.$message.error('Irregular characters')
          } else {
            this.$message.success('Successful operation')
            // 关闭对话框
            this.editDialogVisiblePay = false
            // 刷新数据列表
            this.search()
          }
        })
      } else {
        //支付金额与年数为空提示
        this.$message.success(
          'The number of years and payment amount cannot be empty'
        )
      }
    },
    // 修改设备信息并提交
    async editEquipmentPayInfo() {
      this.addForm.agencyId = this.user.companyId
      this.$refs.editFormRef.validate(async (valid) => {
        if (!valid) return
        this.$post('equipmentPay/update', this.addForm).then(
          ({ data: res }) => {
            console.log(res)
            if (res.msg !== 'SUCCESS') {
              return this.$message.error('operation failed')
            }
            this.$message.success('Successful operation')
            this.addForm = {}
            // 刷新数据列表
            this.search()
            // 关闭对话框
            this.editDialogVisible = false
          }
        )
      })
    },
    // 监听修改对话框的关闭事件
    editDialogClosed() {
      //this.addForm={status:'1'}
      this.$refs.editFormRef.resetFields()
    },
    search(){
        this.queryInfoparams.current=0
         this.getEquipmentPaytList()
    },

    // 获取查询数据列表
    async getEquipmentPaytList(data) {
      this.user = db.get('user')
      this.type = this.user.userType
     
      this.$post('equipmentPay/pageQuery', this.queryInfoparams).then(
        ({ data: res }) => {
          this.equipmentPayList = res.records
          this.total = res.total
        }
      )
    },
    //获取所有的水工
    getEngineerList() {
      this.$post('engineer/queryEngineers', this.queryInfoparams).then(
        ({ data: res }) => {
          this.engineerList = res
        }
      )
    },
    //获取所有的代理商
    getAgencyList() {
      this.$post('agent/queryAgents', this.queryInfoparams).then(
        ({ data: res }) => {
          this.agencyList = res
        }
      )
    },
    //获取所有水工公司
    getCompanyList() {
      this.$post('engineerCompany/queryEngineerCompanys', this.queryInfoparams).then(
        ({ data: res }) => {
          
          console.log("res:"+res)
          this.companyList = res
        }
      )
    },
    addDialogClosed() {
      this.addForm = {}
      this.$refs.addFormRef.resetFields()
    },
    // 监听修改用户对话框的关闭事件
    editDialogClosed() {
      this.addForm = {}
      this.$refs.editFormRef.resetFields()
      
    },
    // 展示编辑设备的对话框
    async showEditDialog(id) {
      console.log(id)
      this.$get(`equipmentPay/getOneById/${id}`).then(({ data: res }) => {
        this.addForm = res.data
      })
      this.editDialogVisible = true
    },
  },
  created() {
    this.search()
    this.getCompanyList()
   
    this.getTestType()
    this.getPaymentStatus()
    if(this.user.userType!='3'){
      
    this.getEngineerList()
    }
    console.log(this.user.userType)
    if(this.user.userType=='1'){

      this.getAgencyList()
    }
  },
}
</script>
<style lang="less" scoped>
.collapse .left .collapse-item span {
  color: #6a6767;
}
.span1 {
  color: #c71d1d;
}
.el-input__inner[SuccessColor='success'] {
  background-color: #3da307;
}
.el-select {
  width: 100%;
}
/deep/.el-collapse-item__content {
  display: flex;
  justify-content: space-between;
}
.searchBtns {
  flex: 1;
  display: flex;
  justify-content: flex-end;
}
/deep/.el-collapse-item__wrap {
  border: none !important;
}
/deep/.el-collapse-item__header {
  border: none !important;
}
.el-row {
  flex: 1;
}
.el-tag {
  order: none !important;
}
.collapse {
  display: flex;
  justify-content: space-between;
}
.el-form-item {
  display: flex;
}
/deep/.el-form-item__content {
  width: 88%;
  margin-left: 0 !important;
}
.btnContainer {
  display: flex;
  justify-content: space-around;
}
</style>